import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";
import { UserModel } from "../apis/types";

export class UserStore {
  rootStore: RootStore;
  userModel: UserModel | null = null;
  minRating: number = 0;
  maxRating: number = 10;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });

    // reaction(
    //   () => ({
    //     user: this.userModel,
    //   }),
    //   async (current, previous) => {
    //     if (current.user) {
    //       this.rootStore.selectCircleStore.fetchCirclePlayers(
    //         this.getMinRating(),
    //         this.getMaxRating()
    //       );
    //     }
    //   }
    // );
  }

  getMinRating = () => {
    const userRating = this.userModel?.userRating || 0;
    let minRating = 1;
    if (userRating > 1) {
      minRating = userRating - 1;
    }
    return minRating;
  };

  getMaxRating = () => {
    const userRating = this.userModel?.userRating || 0;
    let maxRating = 10;
    if (userRating < 10) {
      maxRating = userRating + 1;
    }
    return maxRating;
  };
}
